
  import * as shopifyRuntime$j0csEdapYXNyejT08qGlL2f6l40O_EuBj4u4SNS3i2E from '/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/apps/online-store/utils/shopify-images.ts'
import * as ipxRuntime$Eos_45emmrkjvQX0yL6bvb3tQ7pDFC5sTZoq_LMlxFKLM from '/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/node_modules/.pnpm/@nuxt+image@1.11.0_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ]
},
    providers: {
        ['shopify']: { provider: shopifyRuntime$j0csEdapYXNyejT08qGlL2f6l40O_EuBj4u4SNS3i2E, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$Eos_45emmrkjvQX0yL6bvb3tQ7pDFC5sTZoq_LMlxFKLM, defaults: {} }
    }
  }
